import React from "react";
import "./lawyerprofile.css";
import { useState } from "react";
import InternshipPage from "./lawyerComponents/InterShipPage";
import ListOfLaywers from "./lawyerComponents/ListOfLawyers";
import ReachOutAmount from "./lawyerComponents/ReachOutAmount";

const LawyerProfiles = () => {
  const [selectedPage, setSelectedPage] = useState("Lawyer_Registration");
  

  const renderContent = () => {
    switch (selectedPage) {
      case "Lawyer_Registration":
        return <InternshipPage/>;
      case "ListOfLaywers":
        return <ListOfLaywers/>;
      case "ReachOutAmount":
        return <ReachOutAmount/>;  
    }
  };

  return (
    <div style={{ display: "flex" }}>
    
      <div className="sidebarContainer">
        <ul className="submenuClient">
          <li>
            <a
              href="#"
              className="submenuClient-item"
              onClick={() => setSelectedPage("Lawyer_Registration")}
            >
              Lawyer Registration
            </a>
          </li>
          <li>
            <a
              href="#"
              className="submenuClient-item"
              onClick={() => setSelectedPage("ListOfLaywers")}
            >
              List of lawyers
            </a>
          </li>
          <li>
            <a
              href="#"
              className="submenuClient-item"
              onClick={() => setSelectedPage("ReachOutAmount")}
            >
              Reach Out Amount
            </a>
          </li>
        </ul>
      </div>

      <div className="contentContainer">{renderContent()}</div>
    </div>
  );
};

export default LawyerProfiles;
